import React, { memo } from 'react';
import { PRODUCT_UPLOAD_TEMPLATE_XLSX_URL } from '../../../../constants/service/common/staticFileUrlConstants';
import { productListColumns, selectedProductListColumns } from './columns';
import Section from '../../../../components/outline/Section';
import Button from '../../../../components/Button';
import Anchor from '../../../../components/link/Anchor';
import TableTransfer from '../../../../components/input/TableTransfer';
import ExcelUploadForm from '../../../../components/form/ExcelUploadForm';
import { getCouponProductValidationClassName } from '../../../../lib/utils/couponUtils';
import {
  COUPON_PRODUCT_ITEM_LIST_FILTER_OPTION_MODEL,
  COUPON_PRODUCT_ITEM_LIST_SORT_OPTION_MODEL,
} from '../../../../store/modules/coupon/models';
import { _LIST_PAGINATION_MODEL } from '../../../../store/modules/app/models';
import './CouponProductLinkInfo.scss';

const CouponProductLinkInfo = (props) => {
  const {
    couponProductLinkInfo,
    mainProductCategorySelectList,
    subProductCategorySelectList,
    getCouponProductItemList,
    getCouponProductItemListExcelDownload,
    selectCouponProductItemList,
    getSelectedCouponProductItemListExcelDownload,
    checkValidCouponProductItemListExcelUpload,
    discountType,
    discountAmount,
    maxDiscountPrice,
    getProductSubCategoryList,
  } = props;
  const { itemList, selectedItemList, selectedItemBrandCount } = couponProductLinkInfo;

  return (
    <div className="coupon-product-link-info">
      <Section className="coupon-check-product-item tap-section" title="적용 상품 선택">
        <div className="notice">
          적용 가능 상품은 상품별 할인정책에 따라 변동될 수 있습니다.
          <br />
          선택된 상품이 비적합한 상품으로 변동될 시, <span>주황색</span>으로 표시되고, APP/WEB 에서는 자동적으로
          숨김처리 됩니다.
        </div>

        <TableTransfer
          dataSource={itemList.list}
          operations={['연결', '해제']}
          leftTitle="상품 리스트"
          rightTitle="선택된 상품 리스트"
          leftTableProps={{
            columns: (utils) =>
              productListColumns({
                ...utils,
                mainProductCategorySelectList,
                subProductCategorySelectList,
                getProductSubCategoryList,
                isFilter: true,
              }),
            headInfo: (
              <div className="coupon-check-product-item-head">
                <div className="excel-button-list">
                  <Button isRadius color="light" text="엑셀 다운로드" onClick={getCouponProductItemListExcelDownload} />
                </div>
              </div>
            ),
            rowClassName: (record) => (record.uncheckable ? 'uncheckable' : null),
            getList: getCouponProductItemList,
            pagination: itemList.pagination,
            sortOption: itemList.sortOption,
            filterOption: itemList.filterOption,
            initialOption: {
              filterOption: COUPON_PRODUCT_ITEM_LIST_FILTER_OPTION_MODEL,
              sortOption: COUPON_PRODUCT_ITEM_LIST_SORT_OPTION_MODEL,
              pagination: _LIST_PAGINATION_MODEL,
            },
          }}
          rightTableProps={{
            columns: (utils) =>
              selectedProductListColumns({
                ...utils,
                getProductSubCategoryList,
              }),
            headInfo: (
              <div className="selected-coupon-check-product-item-head">
                <div className="selected-coupon-check-item-count-info">
                  <div className="selected-coupon-check-product-item-count">
                    선택된 아이템 개수 <span>{selectedItemList.list.length}</span>
                  </div>
                  <div className="selected-coupon-check-brand-item-count">
                    선택된 브랜드 개수 <span>{selectedItemBrandCount}</span>
                  </div>
                </div>

                <div className="excel-button-list">
                  <Anchor
                    text="상품 업로드 템플릿"
                    isUnderLine
                    color="primary"
                    href={PRODUCT_UPLOAD_TEMPLATE_XLSX_URL}
                    target="_blank"
                  />

                  <ExcelUploadForm
                    onChange={(file) => checkValidCouponProductItemListExcelUpload(file)}
                    btnText="상품 엑셀 업로드"
                  />

                  <Button
                    isRadius
                    color="light"
                    text="엑셀 다운로드"
                    onClick={getSelectedCouponProductItemListExcelDownload}
                  />
                </div>
              </div>
            ),
            list: selectedItemList.list,
            rowClassName: (record) =>
              getCouponProductValidationClassName(discountType, record.salesPrice, discountAmount, maxDiscountPrice),
          }}
          onChange={(action, moveIdList) => selectCouponProductItemList(action, moveIdList)}
        />
      </Section>
    </div>
  );
};

export default memo(CouponProductLinkInfo);
